<template lang="html">
  <div :class="{ error: error }" class="tab-item">
    <font-awesome-icon class="faTab" :icon="icon" />
    <small class="tab-item-text ml-2">
      <span
        ><strong>{{ heading }}</strong></span
      >
      <span v-if="subheading">&nbsp;{{ subheading }}</span>
    </small>
  </div>
</template>

<script lang="js">
  export default  {
    name: 'tab-item',
    props: {
      icon: {
        type: String,
        required: true
      },
      heading: {
        type: String,
        required: true
      },
      subheading: {
        type: String,
        required: true
      },
      error: {
        type: Boolean
      }
    },
    mounted() {

    },
    data() {
      return {

      }
    },
    methods: {

    },
    computed: {
    }
}
</script>

<style scoped lang="scss">
.tab-item {
  display: inline-flex;
  align-items: center;
}

.faTab {
  font-size: 20px;
}

.tab-item-text {
  display: inline-block;
}

span {
  display: block;
}

.error {
  color: #dc3545;
}
</style>
